import { DisplayWhenHasModules } from 'components.layouts/five-up/five-up-utils.js';
import { ModuleArrLoad } from 'layout/module-load/module-load-arr.js';
import { ModulesLazyLoadWrapper } from 'layout/module-load/modules-lazy-load-wrapper.js';
import { getModulesMetaData } from 'layout/module-load/modules-meta-data.js';
import { IPrimarySlotPropsMap } from 'redux-state/layout/types.layout.js';
import { ModulePath } from 'utilities/modulePath/modulePath.js';

/** Additional Content That Gets Merged into Left Slot Position */
export const MapLeftSlotAdditional = ({
  filteredPrimaryConfig,
  classes,
  name,
}: {
  filteredPrimaryConfig: IPrimarySlotPropsMap;
  classes: string;
  name: string;
}) => {
  const { leftMajor, leftMinor } = filteredPrimaryConfig;

  return (
    <>
      <DisplayWhenHasModules section={leftMajor}>
        <ModulesLazyLoadWrapper
          section={getModulesMetaData(`${name}-leftMajor`, leftMajor.modules)}
          className={classes}
        >
          <ModuleArrLoad modules={leftMajor.modules} modulePath={ModulePath.PRIMARY_LEFT_MAJOR} />
        </ModulesLazyLoadWrapper>
      </DisplayWhenHasModules>

      <DisplayWhenHasModules section={leftMinor}>
        <ModulesLazyLoadWrapper
          section={getModulesMetaData(`${name}-leftMinor`, leftMinor.modules)}
          className={classes}
        >
          <ModuleArrLoad modules={leftMinor.modules} modulePath={ModulePath.PRIMARY_LEFT_MINOR} />
        </ModulesLazyLoadWrapper>
      </DisplayWhenHasModules>
    </>
  );
};
